<template>
  <div class="invoice-records-wrapper">
    <div class="tip">
      本功能仅可开具使用中金支付时产生的手续费发票，发票开具方为中金支付公司，其中纸质专票不支持线上冲红，页面显示的“开票金额”
      为预估金额，实际开票金额请以发票信息为准
    </div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container" style="padding-top: 20px">
      <tableList
        rowKey="id"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template v-slot:month="slot">
          <span>{{dealMonth(String(slot.scope.row.month))}}</span>
        </template>
        <template v-slot:customer="slot">
          <span v-if="Number(slot.scope.row.invoiceType) === 2">{{slot.scope.row.customer}}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:invoiceStatus="slot">
          <div class="flex-all-center">
            <span style="margin-right: 4px">{{formatStatus(Number(slot.scope.row.invoiceStatus))}}</span>
            <eui-tooltip
                    v-if="slot.scope.row.invoiceStatus === 23"
                    :content="slot.scope.row.msg"
                    placement="top"
                    style="cursor: pointer"
            >
              <div class="eicon-problem">
                <eui-icon icon="eicon-r-l-jingshi"  font-size="18px" class="nprmal" color="#C5C5C5"/>
                <eui-icon icon="eicon-r-jingshi"  font-size="18px" class="press" color="#C5C5C5"/>
              </div>
            </eui-tooltip>
          </div>
        </template>
        <template v-slot:operate="slot">
          <eui-btn type="text" color="#0064c8,#004898,#004898" @click="handleView(slot.scope.row.id)">查看</eui-btn>
          <eui-btn type="text" color="#0064c8,#004898,#004898" v-if="slot.scope.row.invoiceStatus === 12 || slot.scope.row.invoiceStatus === 23" @click="handleInvoiceOffsetRed(slot.scope.row.id,slot.scope.row.invoiceType)">冲红</eui-btn>
        </template>
      </tableList>
      <div class="pagination flex-end">
        <el-pagination
          background
          :page-sizes="[10, 20,50,100,200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!--查看开票信息-->
    <apply-for-invoice-dialog
      :applyForInvoiceVisible.sync="applyForInvoiceVisible"
      :recordMonthIdList="recordMonthIdList"
      v-if="applyForInvoiceVisible"
      title="查看发票信息"
    />
    <!-- 发票冲红弹框-->
    <invoice-offset-red-dialog
      v-if="invoiceOffsetRedVisible"
      :invoiceOffsetRedVisible.sync="invoiceOffsetRedVisible"
      :invoiceId="invoiceId"
      :invoiceType="invoiceType"
      ref="invoiceOffsetRed"
    />
  </div>
</template>

<script>
import tableList from '../../components/common/e-table-list';
import eSearch from '../../components/common/e-search';
import api from '@/modules/projectA/api/pay';
import applyForInvoiceDialog from './common/applyForInvoiceDialog';
import invoiceOffsetRedDialog from './common/invoiceOffsetRedDialog';
export default {
  components: {
    tableList,
    eSearch,
    applyForInvoiceDialog,
    invoiceOffsetRedDialog,
  },
  data() {
    return {
      recordMonthIdList: [],
      invoiceId:'',
      invoiceType:2,
      applyForInvoiceVisible: false,
      invoiceOffsetRedVisible: false,
      filterInfo: {
        data: {
          invoiceNumber: null,
          invoiceType: null,
          invoiceStatus: null,
          invoiceCode:null,
        },
        fieldList: [
          { label: '发票号码', type: 'input', value: 'invoiceNumber' },
          { label: '发票代码', type: 'input', value: 'invoiceCode' },
          {
            label: '发票类型',
            type: 'select',
            value: 'invoiceType',
            list: 'invoiceTypeList',
          },
          {
            label: '开票状态',
            type: 'select',
            value: 'invoiceStatus',
            list: 'invoiceStatusList',
          },
        ],
      },
      listTypeInfo: {
        invoiceStatusList: [
          { id: null, name: '全部开票状态' },
          { id: 12, name: '已开票' },
          { id: 22, name: '已冲红' },
          { id: 21, name: '处理中' },
          { id: 11, name: '开票中' },
          { id: 23, name: '冲红失败' },
        ],
        invoiceTypeList: [
          { id: null, name: '全部发票类型' },
          { id: 1, name: '电子普票' },
          { id: 2, name: '电子专票' },
        ],
      },
      tableData: [],
      tableLabel: [
        { label: '发票号码', param: 'invoiceNumber', align: 'center',width:'120' },
        { label: '发票代码', param: 'invoiceCode', align: 'center',width:'150' },
        { label: '开票月份', param: 'month', align: 'center',width:'120',slot:'month' },
        { label: '发票抬头', param: 'customer', align: 'center',slot:'customer' },
        {
          label: '开票状态',
          param: 'invoiceStatus',
          align: 'center',
          width:'120',
          slot:'invoiceStatus',
        },
        {
          label: '发票类型',
          param: 'invoiceType',
          align: 'center',
          width:'90',
          render: ({ invoiceType }) => {
            return Number(invoiceType) === 1 ? '电子普票' : '电子专票';
          },
        },
        { label: '操作', param: '', align: 'center', slot: 'operate' ,width:'180',},
      ],
      queryData: {
        invoiceNumber: null,
        invoiceType: null,
        invoiceStatus: null,
        invoiceCode:null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  methods: {
    formatStatus(invoiceStatus) {
      let status = '';
      switch (invoiceStatus) {
        case 11:
          status = '开票中';
          break;
        case 12:
          status = '已开票';
          break;
        case 21:
          status = '处理中';
          break;
        case 22:
          status = '已冲红';
          break;
        case 23:
          status = '冲红失败';
          break;
      }
      return status;
    },
    dealMonth(month){
      const preMonth = month.substring(0,4);
      const sufMonth = month.substring(4,6);
      return preMonth + '-' +sufMonth;
    },
    handleInvoiceOffsetRed(id,invoiceType){
        this.invoiceId = Number(id);
        this.invoiceType = Number(invoiceType);
        this.invoiceOffsetRedVisible = true;
    },
    handleView(id) {
      this.recordMonthIdList = [id];
      this.applyForInvoiceVisible = true;
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryPaymentInvoicePage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.queryPaymentInvoicePage();
    },
    handleFilter(val) {
      this.queryData.pageNum = 1;
      this.queryData.invoiceNumber = val.invoiceNumber;
      this.queryData.invoiceType = val.invoiceType;
      this.queryData.invoiceStatus = val.invoiceStatus;
      this.queryData.invoiceCode = val.invoiceCode;
      this.queryPaymentInvoicePage();
    },
    handleReset() {
      this.queryData = {
        invoiceNumber: null,
        invoiceType: null,
        invoiceStatus: null,
        invoiceCode:null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      this.queryPaymentInvoicePage();
    },
    async queryPaymentInvoicePage() {
      const res = await api.queryPaymentInvoicePage(this.queryData);
      if (res.success) {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total;
      }
    },
  },
  mounted() {
    this.queryPaymentInvoicePage();
  },
};
</script>

<style scoped lang="scss">
.invoice-records-wrapper {
  .tip {
    width: 100%;
    background-color: #e8efff;
    padding: 15px 10px;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .eicon-problem{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .press{
      display: none;
    }
    transition: 0.6s ;
    &:hover{
      .nprmal{
        display: none;
      }
      .press{
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    &.icon-disabled{
      cursor: not-allowed;
      .nprmal{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .press{
        display: none;
      }
    }
  }
}
</style>
